import { Platform } from "../platform";
import { Requirement } from "../requirement";

export enum SdkCategory {
    MEDIATION = "mediation",
    AD_NETWORK = "ad_network",
    SERVICE = "service",
    OTHER = "other",
}

export enum SdkStability {
    STABLE = "stable",
    BETA = "beta",
    ALPHA = "alpha",
    CUSTOM = "custom",
}

export interface Sdk {
    id?: number
    status: string
    name: string
    version: string
    createdAt: string,
    updatedAt: string,
    category: SdkCategory
    stability: SdkStability
    requirement: Requirement
    platform: Platform
    message?: string
    reindexEnabled?: boolean
}